var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComillas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_2_00000045607957785142545670000010936449010069115546_",
    x: "0px",
    y: "0px",
    viewBox: "0 0 132.7 95.7",
    style: {
      enableBackground: "new 0 0 132.7 95.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\t.st0{fill:#89E394;}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,49V35.4C0,28.3,0.9,22.5,2.6,18s4.6-8.4,8.8-11.6s8.8-5.3,14-6.4v10.9c-3.7,2.1-5.8,5-6.3,8.5h6.3V49   C25.4,49,0,49,0,49z M33.8,49V35.4c0-7.1,0.9-12.9,2.6-17.5S41,9.5,45.2,6.4S54,1.1,59.2,0v10.9c-3.7,2.1-5.8,5-6.3,8.5h6.3V49   H33.8L33.8,49z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M98.8,46.7v13.6c0,7-0.8,12.9-2.5,17.4s-4.6,8.4-8.7,11.6c-4.2,3.2-8.8,5.3-14.1,6.4V84.8   c3.7-2.1,5.9-4.9,6.4-8.4h-6.4V46.7C73.5,46.7,98.9,46.7,98.8,46.7z M132.7,46.7v13.6c0,7-0.8,12.9-2.5,17.4   c-1.7,4.6-4.6,8.4-8.7,11.6c-4.2,3.2-8.8,5.3-14.1,6.4V84.8c3.7-2.1,5.8-4.9,6.3-8.4h-6.3V46.7H132.7L132.7,46.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComillas);
export default __webpack_public_path__ + "static/media/comillas.a29f31819181c11fcd3a0bf262df3b64.svg";
export { ForwardRef as ReactComponent };